import CustomSelectBox from "@components/input/CustomSelectBox";
import CustomTextInput from "@components/input/CustomTextInput";
import LabelWithInput from "@components/input/LabelWithInput";
import styled from "@emotion/styled";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const BirthDateWrapper = styled.div({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "1.2rem",
  width: "100%",
});
const CustomSelectWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: "100%",
  fontSize: "1.6rem",
});

const Date = styled.div({
  fontSize: "1.6rem",
});

export const Birthday = () => {
  const { t } = useTranslation();
  const { setValue, watch } = useFormContext();
  const lang = window.localStorage.getItem("language");

  // 생년월일을 위한 옵션들
  const months = Array.from({ length: 12 }, (_, i) =>
    (i + 1).toString().padStart(2, "0"),
  ); // '01'~'12'
  const days = Array.from({ length: 31 }, (_, i) =>
    (i + 1).toString().padStart(2, "0"),
  ); // '01'~'31'

  const handleChange = (field: string, value: string) => {
    setValue(field, value);
  };
  return (
    <div>
      <LabelWithInput label={"생년월일"}>
        <BirthDateWrapper>
          <BirthDateWrapper>
            <CustomTextInput
              name="year"
              placeholder="YYYY"
              type="number"
              mode="numeric"
              isNumber
              max={4}
              fontSize="1.6rem"
            />

            {lang === "ko" && <Date>{t("년")}</Date>}

            <CustomSelectWrapper>
              <CustomSelectBox
                placeholder={t("월")}
                options={months.map((month) => ({
                  value: month,
                  label: `${month} `,
                }))}
                name="month"
                onChange={(value) => handleChange("month", value)}
                value={watch("month")}
              />
            </CustomSelectWrapper>
            {lang === "ko" && <Date>{t("월")}</Date>}

            <CustomSelectWrapper>
              <CustomSelectBox
                placeholder={t("일")}
                options={days.map((days) => ({
                  value: days,
                  label: `${days} `,
                }))}
                name="day"
                onChange={(value) => handleChange("day", value)}
                value={watch("day")}
              />
            </CustomSelectWrapper>
            {lang === "ko" && <Date>{t("일")}</Date>}
          </BirthDateWrapper>
        </BirthDateWrapper>
      </LabelWithInput>
    </div>
  );
};
